import React from 'react';
import styled from 'styled-components';

import Button from '@jobcase/react_pattern_library/components/Button';
import Typography, { VARIANTS } from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

import Head from '../Head';

import { routeToJobcaseHome } from '../../redux/nodes/router/actions';

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 80px;

  @media (min-width: ${styles.breakpoint.md}) {
    height: calc(100vh - 108px);
    padding-top: unset;
    width: 100%;
  }
`;

const StyledTypography = styled(Typography)`
  text-align: left;

  @media (min-width: ${styles.breakpoint.md}) {
    text-align: center;
  }
`;

const StyledButton = styled(Button)`
  margin-top: ${styles.spacing.small * 3}px;
  width: 100%;
  padding: unset;

  @media (min-width: ${styles.breakpoint.md}) {
    max-width: 215px;
  }
`;

const UnauthorizedAccessWidget = () => (
  <>
    <Head title="Looks like you don’t have access to this page" />
    <StyledContainer>
      <StyledTypography variant={VARIANTS.H1}>
        Looks like you don’t have access to this page.
      </StyledTypography>
      <StyledTypography>
        You don&apos;t have access to the Employer Center with this account.
        {' '}
        If you expected access, ask your organization administrator to add you or update your permissions.
      </StyledTypography>
      <StyledButton onClick={routeToJobcaseHome}>
        Go to Jobcase.com
      </StyledButton>
    </StyledContainer>
  </>
);

export default UnauthorizedAccessWidget;
